import KeycloakService from '@/security/KeycloakService.js'
import { podeAcessarRota } from '@/router/permissoes.js'

// Itens do menu lateral (MainSidebar.vue). Fora do componente para o teste conferir que todo link
// aponta para uma rota com `meta.roles` (menu.spec.js).
//
// Quem vê cada página é decidido pela ROTA (`meta.roles`, veja @/router/permissoes.js), a mesma regra
// que barra a URL digitada — assim menu e tela não divergem (TRI-107). A pasta aparece quando tem ao
// menos uma página visível; `nonAllowedUsers` na pasta ainda esconde tudo dela de quem tem a role.
//
// `allowedUsers` numa página é a exceção, para rota que ainda não tem `meta.roles` por depender de
// decisão do time (Gerência de Processos, Invoices, Solicitação de Câmbio). Nesse caso o admin passa,
// como antes. Ao guardar a rota, tire o `allowedUsers` daqui.

export const menu = [
  {
    folder: 'Agenda',
    icon: 'flaticon-list',
    pages: [
      // [PLOP-TAG] sidebar-agenda
      {
        name: 'Tarefas',
        link: '/agenda',
      }
    ]
  },
  {
    folder: 'Operacional',
    icon: 'flaticon-layer-2',
    pages: [
      // [PLOP-TAG] sidebar-operacional
      {
        name: 'Gerência de Processos',
        link: '/gerencia-processos',
        allowedUsers: ['allow_gerencial_processos', 'operacional_prana', 'colaborador_satya', 'cliente', 'prana_vendedores']
      },
        {
          name: 'Containers',
          link: '/containers',
        },
      {
        name: 'Solicitação de Estimativa de Numerário',
        link: '/projecoes-comerciais/nova',
      },
      {
        name: 'Invoices',
        link: '/invoices',
        allowedUsers: ['invoice', 'admin', 'coordenador_operacional', 'cliente', 'prana_vendedores']
      },
      {
        name: 'Títulos Liberados',
        link: '/titulos-liberados',
      },
      {
        name: 'Solicitação de Câmbio',
        link: '/solicitacaoCambio',
        allowedUsers: ['admin', 'operacional_prana']
      },
    ]
  },
  {
    folder: 'Satya',
    icon: 'flaticon-wallet',
    pages: [
      {
        name: 'Clientes Satya',
        link: '/clientesSatya',
      },
      {
        name: 'Análise de Crédito',
        link: '/analise-credito',
      },
      {
        name: 'Solicitação de Câmbio',
        link: '/solicitacaoCambio',
        allowedUsers: ['admin', 'colaboradores_satya_cambio']
      },
      {
        name: 'Gerar Documento',
        link: '/documento/gerar',
      },
      {
        name: 'Dashboard',
        link: '/dashboard-satya',
      }
    ]
  },
  {
    folder: 'Financeiro',
    icon: 'flaticon-money',
    pages: [
      // [PLOP-TAG] sidebar-financeiro
      {
        name: 'Notas Fiscais de Saída',
        link: '/notas-fiscais-saida',
      },
      {
        name: 'Previsão de Faturamento',
        link: '/titulos-liberados/financeiro',
      },
      {
        name: 'Controle de Câmbio',
        link: '/controle-cambio',
      },
    ]
  },
  {
    folder: 'Ocorrências',
    icon: 'flaticon-warning',
    pages: [
      // [PLOP-TAG] sidebar-ocorrencias
      {
        name: 'Ocorrências',
        link: '/ocorrencias',
      },
      {
        name: 'Liberações de Trava',
        link: '/gerencia/liberacoes',
      }
    ]
  },
  {
    folder: 'Cadastros',
    icon: 'flaticon-form',
    nonAllowedUsers: ['consultor_externo'],
    pages: [
      // [PLOP-TAG] sidebar-cadastros
      {
        name: 'Análise de Resultado',
        link: '/analise-resultado',
      },
      {
        name: 'Análise Resultado - Parametrização',
        link: '/analise-resultado-parametrizacao',
      },
      {
        name: 'Benefícios',
        link: '/cadastro-beneficio',
      },
      {
        name: 'Cargos',
        link: '/cargos',
      },
      {
        name: 'Categoria de Contrato',
        link: '/categorias-contrato',
      },
      {
        name: 'Centro de Custo',
        link: '/centro-custo',
      },
      {
        name: 'Clientes',
        link: '/clientes',
      },
      {
        name: 'Companhias de Transporte',
        link: '/companhias-transporte',
      },
      {
        name: 'Containers',
        link: '/tipos-containers',
      },
      {
        name: 'Contratos',
        link: '/contratos',
      },
      {
        name: 'Departamentos',
        link: '/departamentos',
      },
      {
        name: 'Empresas',
        link: '/empresa',
      },
      {
        name: 'Equipamentos',
        link: '/equipamento',
      },
      {
        name: 'Família de Clientes',
        link: '/familia-cliente',
      },
      {
        name: 'Feriados',
        link: '/cadastro-feriado',
      },
      {
        name: 'Fornecedores',
        link: '/fornecedores',
      },
      {
        name: 'Funções',
        link: '/organograma/funcoes',
      },
      {
        name: 'Grupos',
        link: '/grupos',
      },
      {
        name: 'NCMs',
        link: '/ncm',
      },
      {
        name: 'Origens/Destinos',
        link: '/origens-destinos',
      },
      {
        name: 'Recintos Alfandegários',
        link: '/recintos-alfandegados',
      },
      {
        name: 'Risco País',
        link: '/risco-pais',
      },
      {
        name: 'Situação País',
        link: '/situacao-pais',
      },
      {
        name: 'Status',
        link: '/status',
      },
      {
        name: 'Taxas',
        link: '/taxas',
      },
      {
        name: 'Times',
        link: '/organograma/times',
      },
      {
        name: 'Tipo de Arquivos',
        link: '/tipoArquivo',
      },
      {
        name: 'Tipo de Tarefas',
        link: '/tarefa-tipos',
      },
      {
        name: 'Tipos de Ocorrências',
        link: '/tipos-ocorrencias',
      },
      {
        name: 'Transportadoras',
        link: '/transportadoras',
      }
    ]
  },
  {
    folder: 'Comercial',
    icon: 'flaticon-worldwide',
    pages: [
      {
        name: 'Kanban de Projeções',
        link: '/projecoes-comerciais',
      }
    ]
  },
  {
    folder: 'Inteligência Comercial',
    icon: 'flaticon-search-1',
    pages: [
      // [PLOP-TAG] sidebar-inteligencia-comercial
      {
        name: 'Perfil de Empresa v2',
        link: '/perfil-empresa/v2',
      },
      {
        name: 'Perfil de Empresa',
        link: '/perfil-empresa',
      },
      {
        name: 'Enriquecer Dados',
        link: '/enriquecer-dados',
      }
    ]
  },
  {
    folder: 'Relatórios',
    icon: 'flaticon-pie-chart',
    pages: [
      // [PLOP-TAG] sidebar-relatorios
      {
        name: 'Solicitações de Compras',
        link: '/relatorios/solicitacao-compra',
      },
      {
        name: 'Solicitações de Viagens',
        link: '/relatorios/solicitacao-viagem',
      },
      {
        name: 'Prev. Faturamento Mensal',
        link: '/relatorios/prev-faturamento-mensal',
      },
      // {
      //   name: 'Prev. Faturamento Mensal Por Cliente',
      //   link: '/relatorios/prev-faturamento-mensal-por-cliente',
      // },
      {
        name: 'Distribuição Processos Por Responsável',
        link: '/relatorios/v2/distribuicao-processos-classificacao-responsavel',
      },
      {
        name: 'Pessoas X Conta Bancária',
        link: '/relatorios/pessoa-conta-bancaria',
      },
      {
        name: 'Processos Estatísticas',
        link: '/relatorios/processos-estatisticas',
      },
      {
        name: 'Variação Cambial',
        link: '/variacao-cambial',
      },
    ]
  },
  {
    folder: 'Dashboards',
    icon: 'flaticon-pie-chart',
    subfolder: [
      {
        folder: 'Operacional',
        pages: [
          {
            name: 'Performance Realizada',
            link: '/dashboards/operacional/performance-realizada',
          },
          {
            name: 'Performance Prevista',
            link: '/dashboards/operacional/performance-prevista',
          },
          {
            name: 'Indicadores Equipe',
            link: '/dashboards/operacional/indicadores-equipe',
          },
          {
            name: 'Painel Gerencial',
            link: '/dashboards/operacional/painel-gerencial',
          }
        ]
      }
    ],
    pages: [
      {
        name: 'Clientes',
        link: '/dashboard-cliente',
      },
    ]
  },
  {
    folder: 'Monitoramento',
    icon: 'flaticon-check-mark-1',
    pages: [
      // [PLOP-TAG] sidebar-monitoramento
    ],
    subfolder: [
      {
        folder: 'Logística',
        pages: [
          {
            name: 'Processos Com Risco De Demurrage',
            link: '/monitoramentos/demurrage',
          },
          {
            name: 'Processos Em Andamento - Falta De Informação De Carregamento',
            link: '/monitoramentos/carregamento-andamento',
          },
          {
            name: 'Processos Com Encerramento - Falta De Informação De Carregamento',
            link: '/monitoramentos/carregamento-encerramento',
          },
          {
            name: 'Processos Em Andamento - Com Informação De Carregamento',
            link: '/monitoramentos/carregamento-andamento-informacoes',
          }
        ]
      },
      {
        folder: 'Trading',
        pages: [
          {
            name: 'Conhecimento De Embarque Sem Preenchimento (Trading)',
            link: '/monitoramentos/conhecimento-sem-embarque-trading',
          }
        ]
      },
      {
        folder: 'Shipping',
        pages: [
          {
            name: 'Conhecimento De Embarque Sem Preenchimento (Shipping)',
            link: '/monitoramentos/conhecimento-sem-embarque-shipping',
          }
        ]
      },
      {
        folder: 'Operação',
        pages: [
          {
            name: 'Processos Sem Invoice',
            link: '/monitoramentos/processo-sem-invoice',
          },
          {
            name: 'Processos em Pré-alerta Chegada',
            link: '/monitoramentos/pre-alerta-chegada',
          },
          {
            name: 'Carga Chegada Sem DI/Duimp',
            link: '/monitoramentos/carga-chegada-sem-di-duimp',
          }
        ]
      }
    ]
  },
  {
    folder: 'Acesso',
    icon: 'flaticon-shield-1',
    pages: [
      // [PLOP-TAG] sidebar-acesso
      {
        // Usuários, grupos e roles do Keycloak (TRI-95); a API aceita só admin e gestao_acesso
        name: 'Gestão de acesso',
        link: '/gestao-acesso',
      },
      {
        name: 'Colaboradores',
        link: '/usuarios/colaboradores',
      },
      {
        name: 'Clientes',
        link: '/usuarios/clientes',
      },
      {
        name: 'Agentes',
        link: '/usuarios/agentes',
      },
      {
        name: 'Logs',
        link: '/logs',
      },
      {
        name: 'Usuários Ativos',
        link: '/usuarios-ativos',
      },
      {
        name: 'Certificados',
        link: '/certificado',
      },
    ]
  },
  {
    folder: "Configurações",
    icon: 'flaticon-setting',
    pages: [
      // [PLOP-TAG] sidebar-configuracoes
      {
        name: 'Configurações',
        link: '/configuracoes',
      },
      {
        name: 'Alertas agendados',
        link: '/alertas-agendados',
      },
      {
        name: 'Form Schema Saver',
        link: '/form-schema-saver',
      }
    ]
  },
  {
    folder: 'People & Culture',
    icon: 'flaticon-people',
    nonAllowedUsers: ['consultor_externo'],
    pages: [
      // [PLOP-TAG] sidebar-people-culture
      {
        name: 'Novo Colaborador',
        link: '/novo-colaborador',
      },
      {
        name: 'Central de notas fiscais do prestador',
        link: '/notas-fiscais-prestador',
      },
      {
        name: 'Folha para a Contabilidade',
        link: '/folha-contabilidade',
      },
      {
        name: 'Ocorrências de funcionários',
        link: '/rh/ocorrencias',
      }
    ]
  }
]

// nonAllowedUsers tem precedência sobre tudo — inclusive sobre o bypass de admin. Por isso é IsGranted
// direto, e não IsNotGranted: ele dispensaria o admin da exclusão.
const pastaBloqueada = (pasta) => KeycloakService.IsGranted(pasta.nonAllowedUsers ?? []) === true

const podeVerPagina = (pagina, resolverRota) => {
  if (pagina.allowedUsers) {
    return KeycloakService.IsGranted([...pagina.allowedUsers, 'admin']) === true
  }

  const rota = resolverRota(pagina.link)

  // Link que não casa com rota nenhuma (ou cai no catch-all) não tem roles a conferir: sem isto ele
  // apareceria para todo mundo e levaria à página de erro.
  if (rota.matched.length === 0 || rota.name === 'errorPage') return false

  return podeAcessarRota(rota)
}

const paginasVisiveis = (paginas, resolverRota) =>
  (paginas ?? []).filter((pagina) => podeVerPagina(pagina, resolverRota))

/**
 * Menu só com o que o usuário pode abrir; pasta e subpasta sem página visível somem.
 * `resolverRota` recebe o link e devolve a rota resolvida (no componente, `router.resolve`).
 */
export const filtrarMenu = (itens, resolverRota) =>
  itens
    .map((pasta) => {
      if (pastaBloqueada(pasta)) return null

      const pages = paginasVisiveis(pasta.pages, resolverRota)
      const subfolder = (pasta.subfolder ?? [])
        .map((sub) => {
          const subPages = paginasVisiveis(sub.pages, resolverRota)

          return subPages.length ? { ...sub, pages: subPages } : null
        })
        .filter(Boolean)

      if (pages.length === 0 && subfolder.length === 0) return null

      return { ...pasta, pages, subfolder }
    })
    .filter(Boolean)
